module.exports = __webpack_public_path__ + "img/icon_email.96610380.svg";